const ownadsSelector = '.ownads:not(.ownads--checked)';
const ownadSelector = '.ownad';
const shownOwnads = [];

function showOwnads() {
  $(ownadsSelector).each(function() {
    const $ownads = $(this);
    $ownads.find(ownadSelector).each(function() {
      const $ownad = $(this);
      if (showOwnad($ownad.data('id'), $ownad.data('display'))) {
        shownOwnads.push($ownad.data('id')),
        $ownad.removeClass('d-none');
        return false;
      }
    });
    $ownads.addClass('ownads--checked');
  });
}

function showOwnad(id, display) {
  if (shownOwnads.indexOf(id) > -1) {
    return false;
  }
  if (display === 'all') {
    return true;
  }
  if (display === 'visitors') {
    return !window.mediaconnectParams || !window.mediaconnectParams.isLoggedIn;
  }
  if (display === 'users') {
    return window.mediaconnectParams && window.mediaconnectParams.isLoggedIn;
  }
  return false;
}

export default function() {
  showOwnads();
  $(window).on('fpgmedia:post_loaded', showOwnads);
}



// WEBPACK FOOTER //
// ./scripts/components/ownads.js